export function getErrorMessage(err) {
  // Axios error shape
  const data = err?.response?.data;
  if (typeof data === 'string' && data.trim()) return data;
  if (data?.message) return String(data.message);
  if (data?.error) return String(data.error);
  if (err?.message) return String(err.message);
  return 'Erro inesperado. Tente novamente.';
}
